import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const PaymentCommunication: Illustration = (props) => (
  <svg viewBox="0 0 224 85" {...illustrationProps(props, { width: 224 })}>
    <path
      d="M40.087.319 7.864.357C3.82.362.544 3.654.55 7.711l.08 68.414c.005 4.057 3.288 7.341 7.333 7.336l32.223-.038c4.045-.005 7.32-3.297 7.315-7.354L47.42 7.655C47.415 3.598 44.132.314 40.087.32Z"
      fill="#178000"
    />
    <path
      d="M14.867 5.557a1.235 1.235 0 0 0 0 .618c.06.197.165.381.31.526.242.236.564.368.898.367.19 0 .38-.04.557-.112.112-.047.23-.086.334-.145.105-.06.21-.145.302-.218.013-.013.026-.02.04-.033 0-.006.012-.013.019-.02a1.6 1.6 0 0 0 .157-.21.904.904 0 0 0 .137-.329c.007-.053.04-.21.033-.303a1.4 1.4 0 0 0-.04-.276c0-.013 0-.02-.007-.033a1.2 1.2 0 0 0-.295-.506 1.346 1.346 0 0 0-.617-.347 2.9 2.9 0 0 0-.354-.052c-.046 0-.099-.007-.145 0-.236.02-.406.046-.61.165a.868.868 0 0 0-.242.19c-.032.034-.071.093-.091.12a.873.873 0 0 0-.092.124 1.146 1.146 0 0 0-.15.586c0 .19.046.368.145.532.053.086.112.171.184.237a.745.745 0 0 0 .315.203.752.752 0 0 0 .38.085.828.828 0 0 0 .38-.086.673.673 0 0 0 .315-.204l.15-.197a.95.95 0 0 0 .131-.5l-.033-.263a.98.98 0 0 0-.256-.434l-.02-.02.151.197s-.006-.013-.006-.02l.098.237s-.006-.026-.013-.04l.033.264v-.033l-.032.263s.006-.033.013-.053l-.098.237.02-.04-.151.198s.02-.02.026-.033l-.197.152s.027-.02.046-.027l-.236.1s.053-.02.079-.02l-.262.033c.059-.007.124 0 .183 0l-.262-.033c.052.006.105.02.157.04l-.236-.1.079.04-.197-.15s.033.025.046.045l-.151-.197s.02.026.026.046l-.098-.237s.006.027.013.04l-.033-.263v.053l.032-.264s-.006.033-.013.053l.098-.237s-.02.033-.026.046l.15-.197s-.045.053-.072.072l.197-.151c-.046.04-.105.066-.157.092l.236-.099c-.085.033-.17.066-.262.086l.262-.033h-.112l.263.032s-.053-.013-.072-.02l.236.1s-.04-.02-.053-.034l.197.151s-.04-.032-.052-.052l.15.197-.032-.053.098.237s-.006-.026-.013-.046l.033.263v-.046l-.032.263v-.013a.677.677 0 0 0 .019-.395.681.681 0 0 0-.118-.368.69.69 0 0 0-.256-.276.748.748 0 0 0-.335-.177l-.262-.032c-.178 0-.341.046-.499.132l-.196.151c-.125.125-.203.27-.255.434l.013.02Zm5.253 1.23c4.014.068 8.027.03 12.033-.12 1.26-.047 1.263-2.02-.002-1.972-4.007.15-8.02.193-12.033.12-1.265-.025-1.263 1.947.003 1.972Zm24.763 68.358c.004 3.281-2.655 5.948-5.92 5.951l-29.783.036c-3.272.004-5.93-2.663-5.935-5.937L3.173 14.6c-.003-2.677 2.165-4.856 4.833-4.86l31.96-.037c2.67-.004 4.842 2.17 4.845 4.847l.072 60.595Z"
      fill="#22AE00"
    />
    <path
      d="m28.007 48.35-2.916-6.286 9.236-10.473h-5.8L18.143 43.625V31.59h-4.802v25.844h4.802V49.95l3.576-4.053 2.227 4.778c1.922 4.098 4.545 6.903 8.682 6.903.665 0 1.478-.072 2.07-.22v-4.134s-.516.112-1.217.112c-2.627-.004-3.92-1.629-5.474-4.986Z"
      fill="#fff"
    />
    <path
      d="M63.68 18.32a8 8 0 0 1 8-8h31.74a8 8 0 0 1 8 8v16.34a8 8 0 0 1-8 8H63.68V18.32Z"
      fill="#FFC7C7"
    />
    <path
      d="M74.46 25.72v16.94H58.683c-1.9 0-2.73-2.4-1.236-3.572L74.46 25.72Z"
      fill="#FFC7C7"
    />
    <path
      d="M118.35 39.11a8 8 0 0 0-8-8H78.61a8 8 0 0 0-8 8v16.34a8 8 0 0 0 8 8h39.74V39.11Z"
      fill="#FFC7C7"
    />
    <path
      d="M111.42 31.11H78.61a8 8 0 0 0-8 8v3.55h32.81a8 8 0 0 0 8-8v-3.55Z"
      fill="#FF9494"
    />
    <path
      d="M107.57 46.51v16.94h15.777c1.9 0 2.73-2.4 1.236-3.573L107.57 46.51Z"
      fill="#FFC7C7"
    />
    <path
      d="M212.903 76.35a3 3 0 0 1 3 3v2.538a3 3 0 0 1-3 3h-80.02a3 3 0 0 1-3-3V79.35a3 3 0 0 1 3-3h80.02Z"
      fill="#97A1FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.924 33.338a2 2 0 0 1 2 2v3.68a2 2 0 0 1-2 2h-1.84v25.346h1.84a2 2 0 0 1 2 2v3.68a2 2 0 0 1-2 2h-15.201a2 2 0 0 1-2-2v-3.68a2 2 0 0 1 2-2h2.608V41.017h-2.608a2 2 0 0 1-2-2v-3.68a2 2 0 0 1 2-2h15.201Zm28.113 7.68h1.84a2 2 0 0 0 2-2v-3.68a2 2 0 0 0-2-2h-15.201a2 2 0 0 0-2 2v3.68a2 2 0 0 0 2 2h2.609v25.346h-2.609a2 2 0 0 0-2 2v3.68a2 2 0 0 0 2 2h15.201a2 2 0 0 0 2-2v-3.68a2 2 0 0 0-2-2h-1.84V41.017Zm31.026 0h-1.84v25.346h1.84a2 2 0 0 1 2 2v3.68a2 2 0 0 1-2 2h-15.201a2 2 0 0 1-2-2v-3.68a2 2 0 0 1 2-2h2.608V41.017h-2.608a2 2 0 0 1-2-2v-3.68a2 2 0 0 1 2-2h15.201a2 2 0 0 1 2 2v3.68a2 2 0 0 1-2 2Z"
      fill="#BEC4FF"
    />
    <path
      d="M170.063 2.222a6.001 6.001 0 0 1 6.255-.005l41.183 25.107c1.726 1.052.98 3.708-1.041 3.708h-86.388c-2.02 0-2.767-2.653-1.044-3.706l41.035-25.104Z"
      fill="#97A1FF"
    />
    <circle cx="173.392" cy="18.025" fill="#BEC4FF" r="8.857" />
  </svg>
);
